import { Box, Stack, styled, Typography } from '@mui/material';

const ContainerWithoutData = styled(Stack)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  backgroundColor: 'rgba(240, 243, 244, 1)',
  boxShadow: '0px 0px 8px rgba(61, 64, 75, 0.15)',
  borderRadius: '8px',
  minHeight: '545px',
  width: '100%',
  margin: '33px 0px 0px 0px',
  [theme.breakpoints.between('sm', 'md')]: {
    minHeight: '520px',
  },
  [theme.breakpoints.down('sm')]: {
    minHeight: '400px',
  },
}));

const BoxContainerBody = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
});

const FindUsImage = styled('img')({
  height: '406px',
  width: '406px',
  objectFit: 'cover',
  margin: '0px',
});
const ImageWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));
const EmptyStateText = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  whiteSpace: 'pre-wrap',
  fontSynthesis: 'none',
  color: theme.palette.primary.main,
  fontWeight: theme.typography.titleText.fontWeight,
  letterSpacing: '0.32px',
  textDecoration: 'none',
  textTransform: 'none',
  marginTop: '24px',
  fontSize: theme.typography.h3.fontSize,
  lineHeight: '48px',
  [theme.breakpoints.between('sm', 'md')]: {
    fontSize: theme.typography.availableBalance.fontSize,
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.button.fontSize,
    lineHeight: '24px',
  },
}));
export const FilterWithoutData = () => {
  return (
    <ContainerWithoutData>
      <BoxContainerBody sx={{ width: { md: '80%', xs: '100%' } }}>
        <ImageWrapper>
          <FindUsImage
            sx={{
              width: { md: '330px', sm: '360px', xs: '200px' },
              height: { md: '330px', sm: '360px', xs: '200px' },
            }}
            src='/assets/images/FindUs.gif'
            alt=''
          />
        </ImageWrapper>
        <EmptyStateText>No hay coincidencias, inténtalo nuevamente por favor</EmptyStateText>
      </BoxContainerBody>
    </ContainerWithoutData>
  );
};
